import { BreadcrumbButton } from './../../../core/services/breadcrumb/breadcrumb.interface';
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BadgeOptions } from '../../../components/badge/badge.interface';
import { Breadcrumb } from '../../../core/services/breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';
import { UtilityService } from '../../../core/services/utility_functions/utility_functions.service';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { Subscription } from 'rxjs';
import dayjs from 'dayjs';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { ZuperSdkService } from 'app/core/services/sdk_service/sdk.services';
import { map } from 'rxjs/operators';


@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  isLoading: boolean = false;
  subscription: Subscription;
  breadcrumbData: Breadcrumb;
  breadcrumbSubscription: Subscription;
  currentSDKButtonConfigs: any[] = [];
  isURLChanged: boolean = true;
  selected: any;
  ranges: any = {
    'Today': [dayjs(), dayjs()],
    'Yesterday': [dayjs().subtract(1, 'days'), dayjs().subtract(1, 'days')],
    'Last 7 Days': [dayjs().subtract(7, 'days'), dayjs().subtract(1, 'days')],
    'Last 30 Days': [dayjs().subtract(30, 'days'), dayjs().subtract(1, 'days')],
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]
  };
  dropDownKey: any;
  $subscriptions: Subscription[] = [];

  constructor(
    readonly breadcrumbService: BreadcrumbService,
    readonly router: Router,
    readonly utilityService: UtilityService,
    readonly dateFormatPipe: DateFormatPipe,
    readonly analytics: AnalyticsService,
    readonly sdk: ZuperSdkService,
  ) {
    const $breadCrumbSubscription = this.breadcrumbService.subject.pipe(map((itemsList: Breadcrumb) => {
      if(typeof itemsList === 'object') {
        let sdkButtonConfigs = this.sdk.fetchCreatedButtons('BREADCRUMB');
        if(this.isURLChanged){
          this.currentSDKButtonConfigs = sdkButtonConfigs.map((btnConfig: any) => this.breadcrumbService.serializeSDKConfig(btnConfig));
          this.isURLChanged = false;
        }
        itemsList['breadcrumbButtons'] = this.breadcrumbService.addExisitingButtonFromSDK(
          itemsList.breadcrumbButtons || [],
          this.sdk.fetchCreatedButtons('BREADCRUMB'),
          this.currentSDKButtonConfigs
        );
      }
      return itemsList;
    })).subscribe((itemsList: any) => {
      this.dropDownKey = '';
      this.breadcrumbData = itemsList;
    });
    const $sdk = this.sdk.breadcrumbEvent.subscribe((event) => {
      if (event) {
        const uiConfig = event.data.config;
        switch (event.action) {
          case 'create':
            this.addNewBreadCrumbButtonFromSDK(event.data);
            break;
          case 'show':
            this.showOrHideBreadcrumbButtonFromSDK(uiConfig.id, true, event.args || []);
            break;
          case 'hide':
            this.showOrHideBreadcrumbButtonFromSDK(uiConfig.id, false, event.args || []);
            break;
          case 'remove':
            this.removeBreadcrumbButtonFromSDK(uiConfig.id, event.args || []);
            break;
        }
      }
    });
    this.$subscriptions.push($sdk);
    this.breadcrumbService.count = '';
    this.$subscriptions.push($breadCrumbSubscription);
    // check if the url is changed and if it is, then update the isURLChange to false and update the breadcrumbData
    const urlChangeSub$ = this.router.events.pipe(
    ).subscribe((event) => {
      if(event instanceof NavigationEnd){
        this.isURLChanged = true;
      }
    });
    this.$subscriptions.push(urlChangeSub$);
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.$subscriptions.forEach(($sub: Subscription) => {
      $sub.unsubscribe();
    });
  }



  addNewBreadCrumbButtonFromSDK(config: any, isNew = true): void {
    if (config) {
      const ui = config.params['ui.create'][0];
      const serializedConfig = this.breadcrumbService.serializeSDKConfig(config);
      if (ui.position === 'left') {
        this.breadcrumbData.breadcrumbButtons?.splice(
          0, 0, serializedConfig
        );
      } else {
        this.breadcrumbData.breadcrumbButtons?.push(serializedConfig);
      }
      if (isNew) {
        this.sdk.onUICreated(config, ui);
      }
      this.currentSDKButtonConfigs.push(serializedConfig);
    }
  }


  showOrHideBreadcrumbButtonFromSDK(id: string, isShow: boolean, args = []): void {
    this.breadcrumbData.breadcrumbButtons.forEach((item: BreadcrumbButton) => {
      if (item.id === id) {
        const isButtonInSDK = this.currentSDKButtonConfigs.findIndex((btn: any) => btn.id === id);
        const showOrHide = (i: BreadcrumbButton, show: boolean): void => {
          if (show) {
            i.style = i.style ? i.style.replace('hidden', '') : '';
          } else {
            i.style = i.style ? (i.style.includes('hidden') ? i.style : i.style + ' hidden') : 'hidden';
          }
          i.showIf = isShow;
        };
        if (args.length > 0) {
          item.children.forEach((i) => {
            if (args.includes(i.id)) {
              showOrHide(i, isShow);
            }
          });
        } else {
          showOrHide(item, isShow);
        }
        if(isButtonInSDK >= 0){
          this.currentSDKButtonConfigs[isButtonInSDK] = item;
        }
      }
    });
  }

  removeBreadcrumbButtonFromSDK(id: string, args: string[] = []): void {
    const index = this.breadcrumbData.breadcrumbButtons.findIndex(b => b.id === id);
    if (index >= 0) {
      if (args.length > 0) {
        this.breadcrumbData.breadcrumbButtons[index].children = this.breadcrumbData.breadcrumbButtons[index].children.filter(
          (child: BreadcrumbButton) => !args.includes(child.id)
        );
        const sdkButtonConfigIndex = this.currentSDKButtonConfigs.findIndex((btn: any) => btn.id === id);
        if(sdkButtonConfigIndex >= 0){
          this.currentSDKButtonConfigs[sdkButtonConfigIndex] = this.breadcrumbData.breadcrumbButtons[index];
        }
      } else {
        this.breadcrumbData.breadcrumbButtons.splice(index, 1);
        const sdkButtonConfigIndex = this.currentSDKButtonConfigs.findIndex((btn: any) => btn.id === id);
        if(sdkButtonConfigIndex >= 0){
          this.currentSDKButtonConfigs.splice(sdkButtonConfigIndex, 1);
        }
      }
    }
  }

  emitAction(action: any, type: string): void {
    if (action?.event) {
      this.analytics.trackEvent(action?.event);
    }
    // this.breadcrumbService.breadcrumbActionPerformed.next(action);
    if (type === 'CHILD' && action?.displayName) {
      this.breadcrumbService.breadcrumbActionPerformed.next(action.id ? action : action.displayName);
    } else {
      this.breadcrumbService.breadcrumbActionPerformed.next(action);
    }
  }

  emitDropDownAction(action: any): void {
    if (action?.event) {
      this.analytics.trackEvent(action?.event);
    }
    this.breadcrumbService.breadcrumbActionPerformed.next(action?.displayName);
    this.dropDownKey = action?.displayKey ?? action?.displayName;
  }

  setDropDownKey(children): void {
    if (this.dropDownKey) {
      return this.dropDownKey;
    } else {
      this.dropDownKey = children[0]?.displayKey;
    }
  }

  getDisplayKey(data: any, isModule: boolean): string {
    return data?.displayKey && data?.displayKey !== '' ? data?.displayKey : isModule ? data?.moduleName : data?.displayName;
  }

  redirectTo(route: string): void {
    if (route) {
      this.router.navigateByUrl(route);
    }
  }

  getStatusOptions(): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'PRIMARY',
      displayKey: this.breadcrumbService.count,
      displayName: this.breadcrumbService.count,
      displayType: 'listingCount'

    };
    return badgeOption;
  }

  showArrayValue(item: any): boolean {
    return typeof (this.getDisplayKey(item, false)) !== 'string' && Array.isArray(this.getDisplayKey(item, false)) && this.getDisplayKey(item, false).length > 0;
  }

  setBreadcrumbTitle(value): string {
    return this.utilityService.getLocaleValue(value) || value;
  }

  openDatepicker(): void {
    this.pickerDirective.open();
  }

  getButtonGroup(butttonGroup: any): any {
    return butttonGroup.filter((btn: any) => btn.showIf);
  }

  getButtonClass(button: any, defaultClass): string {
    let btnClass = defaultClass;
    if (button?.isPrimary === true || (button?.isPrimary === true && button?.type === 'DROPDOWN')) {
      btnClass = `btn-primary text-white ${btnClass}`;
    }
    if (button?.isPrimary === true && button?.type === 'DROPDOWN_GROUP') {
      btnClass = `btn-primary-border-dropdown-group ${btnClass}`;
    }
    if (button?.isPrimary !== true || (button?.isPrimary !== true && button?.type === 'DROPDOWN')) {
      btnClass = `${btnClass}`;
    }
    if (!this.utilityService.isEmptyOrUndefined(button?.style)) {
      btnClass = `${btnClass} ${button?.style}`;
    }
    return btnClass;
  }

  getStatusBadgeOptions(): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: '',
      color: this.breadcrumbData?.statusBadgeConfig?.color,
      displayName: '',
      extraClass: '',
      enableClick: this.breadcrumbData?.statusBadgeConfig?.enableClick,
    };
    if (typeof this.breadcrumbData?.statusBadgeConfig?.statusData === 'string') {
      badgeOption.type = this.breadcrumbData?.statusBadgeConfig?.statusData;
      badgeOption.displayName = this.breadcrumbData?.statusBadgeConfig?.statusData;
    } else {
      if (this.breadcrumbData?.statusBadgeConfig?.statusData?.type) {
        badgeOption.type = this.breadcrumbData.statusBadgeConfig.statusData.type;
      }
      if (this.breadcrumbData?.statusBadgeConfig?.statusData?.displayName) {
        badgeOption.displayName = this.breadcrumbData?.statusBadgeConfig?.statusData.displayName;
      }
    }
    return badgeOption;
  }

  handleBadgeEvent(event): void {
    if (event?.isClicked) {
      this.breadcrumbService.breadcrumbActionPerformed.next('STATUS_BADGE');
    }
  }

  titleTooltipEnabled(item: any): any {
    const content = this.setBreadcrumbTitle(this.getDisplayKey(item, false));
    if (content?.length > 35) {
      return content;
    }
    return undefined;
  }

  get isCountExist(): boolean {
    return ((this.breadcrumbService.count !== '' || this.breadcrumbService.count > 0) && !['FINANCING'].includes(this.breadcrumbData.moduleKey));
  }
}
